import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { DocumentService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { Validators } from 'ngx-editor';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { EditTemplateBasicFormComponent } from './edit-template-basic-form/edit-template-basic-form.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'create-associated-form',
  templateUrl: './create-associated-form.component.html',
  styleUrls: ['./create-associated-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateAssociatedFormComponent implements OnInit, OnDestroy {
  currentStep = 0;
  subscription: Subscription = new Subscription();
  screenWidth: number;
  vault_user_form_id;
  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;
  documentForm: UntypedFormGroup;
  resizeObservable$: Observable<Event>;
  current_template;
  forms = [];
  currentuserId;
  securityStateObject;
  source;
  loadOnce = true;
  Form1 = [];
  vault_id;
  vault_list = [];

  steps = [
    {
      description: 'name',
      status: 'start',
    },
    {
      description: 'general',
      status: 'start',
    },
  ];
  constructor(
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data,
    private loginService: LoginStoreEffects,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<CreateAssociatedFormComponent>,
    private vaultService: VaultStoreEffects,
    private store: Store,
    private formBuilder: UntypedFormBuilder
  ) {}
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeDialog() {
    this.dialogRef.close({
      success: false,
    });
  }
  saveForm() {
    this.subscription.add(
      this.documentService
        .updateFormTampletData(
          {
            id: this.vault_user_form_id,
            status_progress: 'need to add',
            user_id: this.currentuserId,
            form_data: {
              beneFicaryForm: [],
              dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
              showNotes: undefined,
            },
            user_pk: this.securityStateObject.public_key,
          },
          null,
          undefined,
          undefined,
          false,
          undefined
        )
        .subscribe(
          (res) => {
            if (this.data.fromSuggestion) {
              this.dialogRef.close({
                id: this.vault_user_form_id,
                type: 'entity',
              });
            } else {
              this.createAssociateForm();
            }
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
    this.formName();
  }
  formName() {
    this.subscription.add(
      this.documentService
        .saveNameWithAction({
          form_name: this.documentForm.controls.documentName.value,
          id: this.vault_user_form_id,
          naming_convention: this.current_template.naming_convention,
          dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
          user_id: this.currentuserId,
          current_template: this.current_template,
          filterArrayItems: this.editTemplateBasicForm.filterArrayItems,
          vault_id: this.vault_id,
          vault_list: this.vault_list,
        })
        .subscribe(
          (res) => {
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }
  createAssociateForm() {
    let payload = {
      user_id: +this.currentuserId,
      vault_user_form_id: this.data.vault_user_form_id,
      created_by_user_id: this.currentuserId,
      association_type: this.data?.manageType == 'Financial Account' ? 'account' : this.data?.manageType,
      source: 'onboarding',
      associate_vault_user_form_id: this.vault_user_form_id,
    };

    this.subscription.add(
      this.documentService.createUserFormAssociation(payload).subscribe((result) => {
        // refresh modal
        this.dialogRef.close({
          success: true,
        });
        this.cd.markForCheck();
      })
    );
  }

  ngOnInit(): void {
    this.source = this.data.source;
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentuserId = state.data.id;
          if (this.loadOnce) {
            this.loadOnce = false;
          }
        }
      })
    );

    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
        this.vault_list = state.vaults;
      })
    );

    this.documentForm = this.formBuilder.group({
      documentType: ['', Validators.required],
      documentName: ['', Validators.required],
      status_progress: ['need to add', Validators.required],
      formSelection: ['', Validators.required],
      selectSaveFolder: ['', Validators.required],
      selectOfficeSaveFolder: ['', Validators.required],
      dynamicFieldsForm: new UntypedFormArray([]),
      beneFicaryForm: new UntypedFormArray([]),
      attributeFormsList: new UntypedFormArray([]),
      showNotes: [''],
      physicalLocation: [''],
      notes: [''],
      expiration_date: [''],
      expiration_notification: [''],
      review_date: [''],
      review_notification: [''],
      renewal_notification: [''],
      renewal_date: [''],
      recurring_expiration: [''],
      value_currency: ['USD'],
      value_current_currency: [''],
      value_is_appraisal: [''],
      value_appraisal_date: [''],
    });
    if (this.data?.selectedId) {
      this.current_template = this.forms.find((x) => x.id == this.data.selectedId);
    } else {
      this.current_template = this.forms.find((x) => x.type == this.data.action_type_current.description);
    }
    this.Form1 = this.current_template.template;
    this.createFormId();
  }
  createFormId() {
    let data = {
      user_id: this.currentuserId,
      vault_form_id: this.current_template.id,
      url: 'my-vault/0',
      source: this.source,
      origin: this.data.origin,
      hub_vault_user_form_id: this.data.vault_user_form_id,
    };

    if (data.origin == null || data.origin == undefined) {
      delete data.origin;
    }
    this.subscription.add(
      this.documentService.getforIdForFirstUploadDocument(data).subscribe(
        (res) => {
          try {
            this.vault_id = res['vault_user_form_id'].vault_id;
            this.securityStateObject = res['vault_user_form_id'].public_key;
          } catch (error) {}

          if (res.vault_user_form_id.vault_user_form_id) {
            this.vault_user_form_id = res.vault_user_form_id.vault_user_form_id;
          }

          this.cd.detectChanges();
        },
        (error) => {}
      )
    );
  }
}
